import { InputSwitch } from 'primereact/inputswitch';
import React, { useState } from 'react';
import { putStoreUsersStoreConfig } from '../../../services/StoreUsers/PostStoreUsers';
import { putBrandStoreChargeDiscount } from '../../../services/ChargeDiscount.js/chargeDiscount';

const StatusChange = ({ status, editData, sendDataToStoreConfig, brandId }) => {
  const [statusValue, setStatusValue] = useState(status);

  const handleEditData = (e) => {
    const newStatus = e.value;
    setStatusValue(newStatus);

    let updatedData = {
      ...editData,
      status: newStatus,
    };
    putBrandStoreChargeDiscount(brandId, updatedData)
      .then(response => {
        if (!response.data.error) {
          const Res = response.data;
          if (Res) {
            sendDataToStoreConfig({
              success: true,
            });
          }
      }
    })
    .catch(err => {
      console.error('Error:', err);
    });
  };

  return (
    <div style={{ margin: '10px 0 10px 5px' }}>
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          borderRadius: '15px',
          width: '100%',
        }}
      >
        <InputSwitch checked={statusValue} onChange={handleEditData} />
      </div>
    </div>
  );
};

export default StatusChange;
